import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CHECKOUT } from "@/constants/testIds";
import { XCircle } from "@phosphor-icons/react";

export default function CheckoutCancel() {
  const [params] = useSearchParams();
  const order_id = params.get("order_id");
  return (
    <div className="mx-auto max-w-[700px] px-6 py-40 text-center lg:px-10">
      <XCircle size={72} weight="duotone" className="mx-auto text-[#FF5A1F]" />
      <div data-testid={CHECKOUT.cancelMsg} className="font-label mt-6 text-xs text-[#FF5A1F]">
        / PAYMENT CANCELLED
      </div>
      <h1 className="mt-3 font-display text-5xl font-black tracking-tighter">No worries.</h1>
      <p className="mt-4 text-white/60">
        Your order {order_id ? <b className="text-white">{order_id}</b> : ""} was not charged.
        You can retry any time.
      </p>
      <div className="mt-10 flex justify-center gap-3">
        <Link to="/cart" className="bg-[#FF5A1F] px-6 py-3 font-label text-xs text-black hover:-translate-y-0.5 transition-transform">
          Back to cart
        </Link>
        <Link to="/shop" className="border border-white/20 px-6 py-3 font-label text-xs hover:border-white/50 transition-colors">
          Keep shopping
        </Link>
      </div>
    </div>
  );
}
